module.exports = __webpack_public_path__ + "28110a17f31f0e737be33d0428f423af.png";